import React, {
	useEffect
}from "react"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	managementActions
}from "../store/actions"
import PositionHistory from "./positionHistory"
import history from "../../../helpers/history"
import "./style.css"
import SelectExecutPosition from "../../nsi/ReResponsiblesExecutPosition/SelectExecutPosition"

const Position = (props) => {
	const { userId, form } = props
	const dispatch = useDispatch()
	const { userExecut, removeUserFromReOrgSuccess } = useSelector((state) => state.managementReducer)

	useEffect(() => {
		getUserExecutMethod()
		return () => {
			form.resetFields(["ReOrgUnit", "ReResponsibleExecutPosition", "reOrgUserSignPosition"])
			dispatch(managementActions.clearUserExecut())
		}
	}, [])

	useEffect(() => {
		if (removeUserFromReOrgSuccess)
			history.push("/orgManagement")
	}, [removeUserFromReOrgSuccess])

	useEffect(() => {
		if (userExecut){
			form.setFieldsValue({
				ReOrgUnit                   : userExecut.reOrgUnit,
				ReResponsibleExecutPosition : userExecut.reResponsibleExecutPosition,
				reOrgUserSignPosition		: userExecut.reOrgUserSignPosition
			})
		}
	}, [userExecut])

	const getUserExecutMethod = () => {
		dispatch(managementActions.getUserExecut(userId && { userId: userId }))
	}

	return (
		<>
			<SelectExecutPosition
				form={ form }
				userExecut={ userExecut }
			/>
			<PositionHistory userId={ userId } />
		</>
	)
}

export default Position
